import * as Sentry from '@sentry/remix';
import { ZodiosPlugin } from '@zodios/core';
import { AxiosError } from 'axios';
import { getPublicEnvironment } from '~/components/common/public-environment';

const SKIP_ERROR_HANDLING_URLS: string[] = ['/tournaments'];

const apiErrorPlugin: ZodiosPlugin = {
  name: 'errorErrorPlugin',
  error: async (api, config, err) => {
    const isDevelopment = getPublicEnvironment()?.NODE_ENV === 'development';
    if (
      SKIP_ERROR_HANDLING_URLS.includes(config.url) &&
      config.method === 'get'
    ) {
      if (isDevelopment) {
        console.log('Skipping error handling for', config.url);
      }
      throw err;
    }

    if (err instanceof AxiosError) {
      if (isDevelopment) {
        console.error('[ZodiosAPI] AxiosError', err);
      }
      Sentry.captureException(err);
    }

    throw err;
  },
};

export default apiErrorPlugin;
